import { render } from "./LogBox.vue?vue&type=template&id=52cecc9a&scoped=true"
import script from "./LogBox.vue?vue&type=script&lang=js"
export * from "./LogBox.vue?vue&type=script&lang=js"

import "./LogBox.vue?vue&type=style&index=0&id=52cecc9a&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src2677690992/src/emulator.totogidemos.com/frontend/node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-52cecc9a"]])

export default __exports__